module.exports = __webpack_public_path__ + "img/SOL.a06d503a.png";